<template>
  <ul class="items">
    <li class="menu_item">
      <router-link class="menu_item" active-class="menu_item_active" to="/IndexPage"
        >首页</router-link
      >
    </li>

    <li
      class="menu_item about_menu"
      @mouseover="menuImgChagne('1')"
      @mouseout="menuImgChagne('2')"
    >
      <div class="flex" :class="{ menu_item_active: isabout }">
        <!-- <div class="flex"> -->
        <div class="flex-item">关于我们</div>
        <!-- <img :src="this.aboutMenuIconSrc" /> -->
      </div>
      <div class="menu_subpanel">
        <div class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/AboutPage"
            style="width: 100%"
          >
            公司介绍
          </router-link>
        </div>
        <div class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/CorporatePage"
            style="width: 100%"
          >
            企业文化
          </router-link>
        </div>
        <div class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/TeamPage"
            style="width: 100%"
          >
            主推品牌
          </router-link>
        </div>
      </div>
    </li>
    <!-- <li class="menu_item">
      <router-link class="menu_item" active-class="menu_item_active" to="/NewsPage"
        >新闻资讯</router-link
      >
    </li> -->
    <li class="menu_item about_menu">
      <div class="flex" :class="{ menu_item_active: isUs }">
        <div class="flex-item">产品中心</div>
        <!-- <img src="../assets/down.png" /> -->
      </div>
      <div class="menu_subpanel">
        <div class="menu_sub_item">
          <el-popover placement="right" width="180" trigger="hover">
            <div>配电和工业自动化元件</div>
            <template #reference>
              <router-link
                class="menu_item"
                style="
                  padding-left: 10px;
                  padding-right: 10px;
                  width: 90%;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                active-class="menu_item_active"
                to="/ProductPage?type=1"
                >配电和工业自动化元件</router-link
              >
            </template>
          </el-popover>
        </div>
        <div class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/ProductPage?type=4"
            style="width: 100%"
            >仪器仪表</router-link
          >
        </div>
        <div class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/ProductPage?type=3"
            style="width: 100%"
            >机器人集成</router-link
          >
        </div>
        <div class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/ProductPage?type=2"
            style="width: 100%"
            >清洁系统</router-link
          >
        </div>
      </div>
    </li>
    <li class="menu_item">
      <router-link class="menu_item" active-class="menu_item_active" to="/DigitizePage"
        >数字化服务</router-link
      >
    </li>
    <li class="menu_item about_menu">
      <div class="flex" :class="{ menu_item_active: isUs }">
        <div class="fexl-item" style="width: 100%">解决方案</div>
        <!-- <img src="../assets/down.png" /> -->
      </div>
      <div class="menu_subpanel">
        <div class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/CasePage"
            style="width: 100%"
            >场景方案</router-link
          >
        </div>
        <div class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/CaseVideoPage"
            style="width: 100%"
            >视频方案</router-link
          >
        </div>
        <div v-if="this.isZ" class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/RelatedCasePage"
            style="width: 100%"
            >相关案例</router-link
          >
        </div>
      </div>
    </li>
    <li class="menu_item">
      <router-link class="menu_item" active-class="menu_item_active" to="/ServicePage"
        >服务与支持</router-link
      >
    </li>
    <li class="menu_item about_menu">
      <div class="flex" :class="{ menu_item_active: isUs }">
        <div class="flex-item">联系我们</div>
        <!-- <img src="../assets/down.png" /> -->
      </div>
      <div class="menu_subpanel">
        <div class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/JobPage"
            style="width: 100%"
            >留言咨询</router-link
          >
        </div>
        <div class="menu_sub_item">
          <router-link
            class="menu_item"
            active-class="menu_item_active"
            to="/JobgwPage"
            style="width: 100%"
            >加入我们</router-link
          >
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
import { useStore } from "vuex";
export default {
  data() {
    return {
      aboutMenuIconSrc: require("../assets/down.png"),
      isabout:
        this.$route.name == "AboutPage" ||
        this.$route.name == "CorporatePage" ||
        this.$route.name == "TeamPage",
      isUs: this.$route.name == "JobPage" || this.$route.name == "JobgwPage",
      isCase: this.$route.name == "CaseVideoPage" || this.$route.name == "CasePage",
      store: useStore(),
      isZ: "",
    };
  },
  watch: {
    $route(to) {
      if (to.name == "AboutPage" || to.name == "CorporatePage" || to.name == "TeamPage") {
        this.aboutMenuIconSrc = require("../assets/downhover.png");
        this.isabout = true;
      } else {
        this.aboutMenuIconSrc = require("../assets/down.png");
        this.isabout = false;
      }
      if (to.name == "JobPage" || to.name == "JobgwPage") {
        this.isUs = true;
      } else {
        this.isUs = false;
      }
      if (to.name == "CasePage" || to.name == "CaseVideoPage") {
        this.isCase = true;
      } else {
        this.isCase = false;
      }
    },
  },
  mounted() {
    const user = this.store.state.userInfo;
    this.isZ = user ? (user.permission ? user.permission == 0 : false) : false;
  },
  methods: {
    menuImgChagne: function (status) {
      if (status == "2") {
        this.aboutMenuIconSrc = require("../assets/down.png");
      } else {
        this.aboutMenuIconSrc = require("../assets/downhover.png");
      }
      if (
        this.$route.name == "AboutPage" ||
        this.$route.name == "CorporatePage" ||
        this.$route.name == "TeamPage"
      ) {
        this.aboutMenuIconSrc = require("../assets/downhover.png");
      }
    },
  },
};
</script>
<style>
.items {
  margin: 0;
  padding: 0;
  list-style: none;
}

.items .menu_item {
  display: inline-block;
  width: 140px;
  font-size: 16px;
  text-align: center;
  color: #222;
  cursor: pointer;
  text-decoration: none;
  position: relative;
  /* padding-right: 20px; */
}
.items .menu_item img {
  height: 16px;
  margin-top: 24px;
}

.menu_subpanel {
  position: absolute;
  background: #fff;
  width: 100%;
  padding-bottom: 5px;
  left: 0px;
  z-index: 100;
  display: none;
}
.menu_subpanel .menu_sub_item {
  background: #fff;
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.about_menu:hover .menu_subpanel {
  display: block;
}
.items .menu_item:hover {
  color: #f8b053;
}
.items .menu_item:active {
  color: #f8b053;
}
</style>
